import { Orientation, DeviceType } from 'sofa-reborn-react';
import { IframeUtility } from '@inter-ikea-kompis/utilities';

const SCREEN_SMALL = 576;
const SCREEN_LARGE = 992;

const getOrientation = (): Orientation => {
	return window.innerWidth > IframeUtility.calculateHeight(window.innerWidth)
		? 'landscape'
		: 'portrait';
};

const getDeviceType = (orientation: Orientation): DeviceType => {
	const appWidth = window.innerWidth;

	if (orientation === 'portrait') {
		if (appWidth <= SCREEN_SMALL) {
			return 'mobile';
		} else if (appWidth <= SCREEN_LARGE) {
			return 'tablet';
		} else {
			return 'desktop';
		}
	} else {
		if (IframeUtility.calculateHeight(appWidth) <= SCREEN_SMALL) {
			return 'mobile';
		} else {
			return 'desktop';
		}
	}
};

function debounce(...args): () => void {
	let timeout;
	const func = args[0];
	const wait = args[1];
	const immediate = args[2];
	return function (): void {
		const later = function (): void {
			timeout = null;
			if (!immediate) {
				func.apply(args);
			}
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(args);
		}
	};
}

const resizeHandler = {
	addListener: (handler: (orientation: Orientation, deviceType: DeviceType) => void): void => {
		const notifyHandler = (): void => {
			const orientation = getOrientation();
			const deviceType = getDeviceType(orientation);
			handler(orientation, deviceType);
		};

		const delayedCallback = debounce(notifyHandler, 50, false);

		notifyHandler();

		window.addEventListener('resize', delayedCallback);
	},
};

export default resizeHandler;
